// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const dataAttrSuffix = 'section-intro'
const dataAttr = 'data-' + dataAttrSuffix

class SectionIntro {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.$content = this.$el.find('[' + dataAttr + '-content]')
    this.$text = this.$el.find('[' + dataAttr + '-text]')
    this.init()
  }

  init() {
    this.alphaTl = gsap.timeline({
      defaults: { ease: 'ease-in' },
      scrollTrigger: {
        trigger: this.target,
        start: 'top 80%',
        end: 'top top',
        scrub: true
      }
    })
    .fromTo(this.$content, {opacity: 0}, {opacity: 1})
    .fromTo(this.$text, {y: '30vh'}, {y: 0}, '<')
  }

  destroy() {
    /*
    Kills the ScrollTrigger instance, immediately unpinning and restoring any pin-related changes made to the DOM by ScrollTrigger and removing all scroll-related listeners, etc. so that the instance is eligible for garbage collection.
    */

    if (this.alphaTl) {
      this.alphaTl.scrollTrigger.kill()
      this.alphaTl.kill()
    }

    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }
  }
}

export default {dataAttr: dataAttr, sectionClass: SectionIntro}
